import PaginationControl from './PaginationControl';

export default PaginationControl;
